// toast-route-cleanup.tsx
import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useToastStore } from '../../stores/use-toast-store';

/**
 * This is a global component that is used to clear the toasts when the route is changed.
 */
const ToastRouteCleanup = () => {
  const router = useRouter();
  const clearToasts = useToastStore((s) => s.clear);

  useEffect(() => {
    // Subscribe to router changes and clear toasts on navigation
    const unsubscribe = router.subscribe('onResolved', () => {
      clearToasts();
    });

    return () => {
      unsubscribe();
    };
  }, [router, clearToasts]);

  return null;
};

export default ToastRouteCleanup;
